import './attendance.scss';
//react
import { useEffect, useState } from 'react';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import { useQuery } from '@apollo/client';
//shared
import { Titles } from '../shared/components/titles/titles';
import { TITLE_CLASS_ATTENDANCE } from './constants/title';
import { DatePickerMonthYear } from '../shared/components/date-month-year/date-month-year';
import { DATE_MONTH_YEAR } from './constants/datepicker';
import IFilterAttedance from '../shared/interfaces/filters-attendace.interface';
import { RESERVES_BRANCH } from '../shared/graphql/branch';
import { TableAttendance } from './components/table-attendance/table-attendance';
import TakeAttendance from '../take-attendance/take-attendance';
import ICalendar from '../shared/interfaces/calendar.interface';
import { SkeletonTable } from '../shared/components/skeleton-table/skeleton-table';
//material
import { Box, Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { sendPageView } from '../shared/services/analytics';
import Icon from '../shared/components/icon/icon';

let filters: IFilterAttedance;

function DataTable({ date, branchId, takeAttendance }: { date: Date, branchId: number, takeAttendance: (dataCalendar: ICalendar) => void }) {
    const location = useLocation();
    useEffect(() => {
        sendPageView(location.pathname + location.search, "Asistencias pendientes");
    }, [location]);

    filters = {
        idBranch: branchId,
        start: startOfMonth(date),
        end: endOfMonth(date),
        status: [1, 7],
        page: 1
    };

    const { loading, error, data } = useQuery(RESERVES_BRANCH, {
        variables: filters,
    });

    if (error) console.log(`Submission error! ${error.message}`);

    if (loading) return <SkeletonTable></SkeletonTable>;

    return (
        <div>
            <TableAttendance tableData={data.reservesBranch.data} takeAttendance={(dataCalendar) => takeAttendance(dataCalendar)}></TableAttendance>
        </div>
    );
}

export default function Attendance({ branch }: { branch: number }) {
    const [date, setCount] = useState(new Date());
    const [takeAttendance, setTakeAttendance] = useState<boolean>(false);
    const [dataCalendar, setDataCalendar] = useState<ICalendar>();
    const [daysLeft, setDaysLeft] = useState(25);
    const [countdown, setCountdown] = useState<string>("");

    DATE_MONTH_YEAR.valueDate = date;

    useEffect(() => {
        setTakeAttendance(false);
    }, [branch]);

    useEffect(() => {
        const startDate = new Date("March 10, 2024");
        const endDate = new Date(startDate.getTime() + 10 * 24 * 60 * 60 * 1000);

        const intervalId = setInterval(() => {
            const now = new Date();
            const differenceDays = Math.ceil((endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
            const difference = Math.max(0, endDate.getTime() - now.getTime());
            if (difference <= 0) {
                clearInterval(intervalId);
                setDaysLeft(0);
            } else {
                const days = Math.floor(difference / (1000 * 60 * 60 * 24));
                const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                setCountdown(`${days} días ${hours} horas ${minutes} minutos`);
                setDaysLeft(differenceDays);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const changeSetTakeAttendance = (data?: ICalendar) => {
        if (data) setDataCalendar(data);
        setTakeAttendance(!takeAttendance);
    }

    if (takeAttendance && dataCalendar) return <TakeAttendance attendance={() => changeSetTakeAttendance()} dataCalendar={dataCalendar}></TakeAttendance>;

    return (
        <Box className="contain-attendance">
            <Grid container>
                <Grid item xs={12}>
                    <Titles props={TITLE_CLASS_ATTENDANCE} />
                </Grid>
                <Grid item xs={12}>
                    <DatePickerMonthYear dateData={DATE_MONTH_YEAR} onAction={(newDate: any) => setCount(newDate)}></DatePickerMonthYear>
                </Grid>
                <Grid item xs={12}>
                    {(daysLeft > 0) && (
                        <div className='alert-count'>
                            <Grid container>
                                <Grid item xs={2} sm={1} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                    <Icon name='clock' color='#000000' width='30' height='30'></Icon>
                                </Grid>
                                <Grid item xs={10}>
                                    <p>
                                        Este módulo de Asistencia pendiente, estará disponible únicamente hasta los
                                        próximos <b>{countdown}</b>. Puede tomar la asistencia pendiente de hasta
                                        3 días anteriores desde la parte principal de clases.
                                    </p>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    <DataTable date={date} branchId={branch} takeAttendance={(dataCalendar) => changeSetTakeAttendance(dataCalendar)}></DataTable>
                </Grid>
            </Grid>
        </Box>
    );
}